
import Decimal from 'decimal.js'
import { u128ToDecimal } from '../utils/HedgeConstants'

/**
 * Represents an on-chain pool era. In the event an era is depleted of deposits, a new era is
 * created to maintain each users contribution to the pool.
 */
export class LiquidationPoolEra {
  public totalDeposits: Decimal
  public product: Decimal
  public sum: [Decimal]
  public hedgeRewardsAccumulator: Decimal
  public hedgeRewardsTimestamp: number

  constructor (public liquidityPoolEra: any) {
    this.totalDeposits = new Decimal(liquidityPoolEra.totalDeposits.toString())
    this.product = u128ToDecimal(liquidityPoolEra.productBytes.toString())
    this.sum = liquidityPoolEra.sumBytes.map((sumBytes: number) => { return u128ToDecimal(sumBytes.toString()) })
    this.hedgeRewardsAccumulator = u128ToDecimal(liquidityPoolEra.hedgeRewardsAccumulatorBytes.toString())
    this.hedgeRewardsTimestamp = liquidityPoolEra.hedgeRewardsTimestamp.toNumber()
  }
}
